export const getTableHeight = ({ table_name = "default" }) => {
  if (window.innerHeight < 500) {
    return "40vh";
  }
  if (window.innerHeight < 600) {
    return "50vh";
  }
  if (window.innerHeight < 700) {
    if (table_name && table_name == "po_table") {
      return "50vh";
    }
    if (table_name && table_name == "vendor_table_empanelled") {
      return "50vh";
    }
    if (table_name && table_name == "vendor_table") {
      return "50vh";
    }

    return "55vh";
  }
  if (window.innerHeight < 800) {
    if (table_name && table_name == "po_table") {
      return "55vh";
    }
    if (table_name && table_name == "vendor_table_empanelled") {
      return "50vh";
    }
    if (table_name && table_name == "vendor_table") {
      return "55vh";
    }

    return "60vh";
  }
  if (window.innerHeight < 900) {
    if (table_name && table_name == "po_table") {
      return "60vh";
    }
    if (table_name && table_name == "vendor_table_empanelled") {
      return "50vh";
    }
    if (table_name && table_name == "vendor_table") {
      return "55vh";
    }

    return "65vh";
  }
  if (window.innerHeight < 1000) {
    if (table_name && table_name == "po_table") {
      return "65vh";
    }
    if (table_name && table_name == "vendor_table_empanelled") {
      return "50vh";
    }
    return "70vh";
  }
  if (window.innerHeight < 1200) {
    return "75vh";
  }
};
